/**
 * KAN-1428 — rozpracovaná adresa na pokladně přežije odchod do košíku.
 *
 * Pokladna držela adresu jen ve stavu komponenty; zákazník, který se
 * z ní vrátil do košíku upravit kusy, přišel o všechno, co vyplnil.
 * Koncept se drží v ``sessionStorage``: jen v tomhle panelu prohlížeče
 * a jen do jeho zavření — osobní údaje tak nezůstávají v zařízení déle,
 * než trvá nákup. Po odeslání objednávky se maže.
 *
 * Úložiště může chybět nebo házet (anonymní okno, zakázaná data webu),
 * proto každé čtení i zápis jsou v ``try`` a bez úložiště pokladna
 * funguje jako dřív.
 */

const KEY = "checkout-draft-v1";

export function readCheckoutDraft<T extends object>(): Partial<T> | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as Partial<T>) : null;
  } catch {
    return null;
  }
}

export function writeCheckoutDraft(draft: object): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    // Bez úložiště se koncept prostě neuloží.
  }
}

export function clearCheckoutDraft(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Viz výš.
  }
}
